import { ReduxHelper } from "helpers";
import {
  ICompany,
  ICreateCompanyRequest,
  IDeleteByIdRequest,
  IGetAllCompaniesResponse,
  IGetByIdRequest,
  IGetCompanyByIdResponse,
  IPaginationRequest,
  IUpdateCompanyRequest,
} from "model";

export const prefix = "COMPANY";

export const getAllCompanies = ReduxHelper.generateActions<
  IPaginationRequest,
  IGetAllCompaniesResponse
>(prefix, "GET_ALL_COMPANIES");
export const getCompanyById = ReduxHelper.generateActions<
  IGetByIdRequest,
  IGetCompanyByIdResponse
>(prefix, "GET_COMPANY_BY_ID");
export const createCompany = ReduxHelper.generateActions<
  ICreateCompanyRequest,
  ICompany
>(prefix, "CREATE_COMPANY");
export const updateCompany = ReduxHelper.generateActions<
  IUpdateCompanyRequest,
  ICompany
>(prefix, "UPDATE_COMPANY");
export const deleteCompany = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  { id: string }
>(prefix, "DELETE_COMPANY");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
